import React, { Fragment } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import SegmentIO from 'reporting/SegmentIO';
import { getLegalLinks } from 'shared/clientUtils';
import { breakpoints, colors, fontSize } from 'styles/cp';
import { COUNTRY } from 'types/constants';

export interface MainFooterProps {
  companyLocale: String;
  isPayable: Boolean;
  bottomPadding?: number;
  topPadding?: number;
  redesign?: boolean;
  hideLinks?: boolean;
}

const MainFooter: React.FC<MainFooterProps> = ({
  redesign,
  companyLocale,
  isPayable,
  bottomPadding = 0,
  topPadding = 8,
  hideLinks = false,
}) => {
  const intl = useIntl();
  const { privacyUrl, tosUrl } = getLegalLinks(intl.locale);
  const fullYear = new Date().getFullYear();
  const country = companyLocale.split('_')[1];

  const maybeShowPrivacyLink = () => {
    if (!isPayable && !hideLinks) {
      const onClick = () => {
        SegmentIO.transactionEngaged({
          activity_type: 'optional_actions',
          ui_object: 'link',
          ui_action: 'clicked',
          ui_access_point: 'transaction_flow',
          ui_object_detail: 'privacy_statement',
        });
      };

      return (
        <span className="cp-link">
          &nbsp;
          <a
            id="main-footer-privacy"
            onClick={onClick}
            href={privacyUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage id="INVOICE_VIEW_PAGE_FOOTER_PRIVACY" defaultMessage="Privacy" />
          </a>
        </span>
      );
    }
    return null;
  };

  const maybeShowTOSLink = () => {
    let _show = false;

    if (country === COUNTRY.US || country === COUNTRY.CA) {
      _show = !isPayable && !hideLinks;
    }

    if (_show) {
      const onClick = () => {
        SegmentIO.transactionEngaged({
          activity_type: 'optional_actions',
          ui_object: 'link',
          ui_action: 'clicked',
          ui_access_point: 'transaction_flow',
          ui_object_detail: 'terms_of_service',
        });
      };

      return (
        <span className="cp-link">
          <span> | </span>
          <a
            className="a"
            onClick={onClick}
            href={tosUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage id="INVOICE_VIEW_PAGE_FOOTER_TOS" defaultMessage="Terms of service" />
          </a>
        </span>
      );
    }
    return null;
  };

  return (
    <Fragment>
      <div className="main-footer">
        <FormattedMessage
          id="INVOICE_ALL_RIGHT_RESERVED"
          values={{ '0': fullYear }}
          defaultMessage={`© ${fullYear} Intuit Inc. All right reserved`}
        />
        {maybeShowPrivacyLink()}
        {maybeShowTOSLink()}
      </div>

      <style jsx>{`
        .main-footer {
          font-family: AvenirNextforINTUIT-Regular;
          font-size: ${redesign ? fontSize.xxxs : fontSize.xxs};
          text-align: center;
          color: ${colors.ghostGray};
          padding: ${topPadding}px 8px ${bottomPadding}px;

          @media (max-width: ${breakpoints.md}) {
          }

          a {
            text-decoration: none;

            &:hover {
              text-decoration: underline;
            }
          }
        }
      `}</style>
    </Fragment>
  );
};

export default MainFooter;
